import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { NgbDate, NgbCalendar, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ServiceService } from 'src/app/services/service.service';
import { saveAs as importedSaveAs } from "file-saver";
import { NgbCustomDateParserService } from 'src/app/formatters/ngb-custom-date-parser.service';
import { SortingCurrentStatus, SortingModel } from '../dashboard/components/dashboard-mngnt/sortingModel';
import { UserService } from 'src/app/services/user.service';
import { UtilService } from 'src/app/services/util.service';
import { TakeOrderModel } from '../dashboard/components/dashboard-mngnt/take-order/take-order-model';
import { timeStamp } from 'console';

@Component({
  selector: 'app-emergency-bol',
  templateUrl: './emergency-bol.component.html',
  styleUrls: ['./emergency-bol.component.css']
})
export class EmergencyBolComponent implements OnInit {

  @ViewChild('openModal') errorModal: ElementRef<HTMLElement>;

  noOfRecord: number = 50;

  whoOwnsItsData: any = {};
  user: any;
  allowedTenants: any[] = [];
  billOfLaddingResponse: any = null;
  singleBillOfLaddingDetails = null;
  copiedBillofladings = [];

  terminals = [];
  suppliers = [];
  dealers = [];
  selectedSupplier = null;
  selectedTerminal = null;
  selectedFilter = 'loadingBol';
  filterDivision = null;
  hideCompletedLoads = false;

  selectedTenant = null;
  products = [];
  productList = [];
  takeOrderActive = false;
  availableTanks = [];
  defaultProducts = ["reg", "mid", "prem", "ulsd"];
  newProductAdded = null;
  takeOrderModel: TakeOrderModel = new TakeOrderModel();
  tenants = [];
  userTenant: any;
  billofladingNotes = null;
  

  /**Filter params. */
  public selectedDealer = null;
  public orderNoFilter = null;
  public carrierFilter = null;
  public terminalFilter = null;
  public supplierFilter = null;
  public dealerFilter = null;
  public bolStatusFilter = null;
  public notesFilter = null;
  public invoiceFilter = null;
  public loadingBolFIlter = null;
  public filterQuery = null;
  public bolstatusMap = new Map();
  public selectedReportType = null;

  public showInvoices: boolean = false;
  public hideOrShow: boolean = false;
  public shiftSort: string = 'asc';

  public bolImages = [];
  selectedRouteSheet = {};
  public canUploadFiles = false;

  hoveredDate: NgbDate;

  fromDate: NgbDate;
  toDate: NgbDate;

  modalRef: any;
  selectedItem: any;

  allPageTotals: any;
  totalRegQuantity: any;
  totalMidQuantity: any;
  totalSupQuantity: any;
  totalUlsdQuantity: any;
  totalOthQuantity: any;
  httpRequestllowedTenants = [];
  screenHeight = screen.height - (35 / 100 * screen.height);
  link: any = "";
  errorMsg = "";
  successMsg = "";
  error: boolean = false;
  sortingModels: SortingModel[] = [];
  sortingCurrentStatus: SortingCurrentStatus = new SortingCurrentStatus();
  billofladingidHub = null
  availableDivisions = [];

  public size = 5000;
  public page = 1;
  public clearCache = true;
  public role: any = null;
  public httpRequest: any = null;
  public newDesign = false;
  public allowBolEditFromPortal = true;


  constructor(private calendar: NgbCalendar, public formatter: NgbDateParserFormatter,
    private route: ActivatedRoute,
    private router: Router,
    private ngModal: NgbModal,
    private datePipe: DatePipe,
    private service: ServiceService,
    private ngbCustomDateParserService : NgbCustomDateParserService,
    public userService: UserService,
    private utilService: UtilService) { 
      this.user = JSON.parse(localStorage.getItem("user"));
      // this.userTenant = JSON.parse(localStorage.getItem("user-tenant"));
      this.showInvoices = this.user.user.showInvoices;
      this.role = this.user.user.role.role;
      this.canUploadFiles = this.user.user.canUploadDashboardFiles;
      this.userTenant = this.user.user.tenant.tenantId;
      this.userService.allowBolEdit().subscribe((user:any) => {
        this.allowBolEditFromPortal = user?.allowBolEditFromPortal;
      })
    }

  ngOnInit() {
    this.changeTenantFilter();
    let sortingModel = new SortingModel();
    sortingModel.fieldName = "shift";
    sortingModel.sortingType = "ASC";
    this.sortingModels.push(sortingModel);

    $(".overlay-loading").show();
    this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 0);
    this.toDate = this.calendar.getNext(this.calendar.getToday(), 'd', 0);

    this.user = JSON.parse(localStorage.getItem("user"));
    this.showInvoices = this.user.user.showInvoices;
    this.role = this.user?.role?.authority;

    for (var ctr = 0; ctr < 10; ctr++) {
      this.bolstatusMap.set(ctr + '', "Order Received");
    }

    // this.bolstatusMap.set("1", "Order Received");
    this.bolstatusMap.set("10", "Dispatched");
    this.bolstatusMap.set("12", "Enroute to Rack");
    this.bolstatusMap.set("20", "At Rack");
    this.bolstatusMap.set("22", "Left Rack");
    this.bolstatusMap.set("24", "At Location");
    this.bolstatusMap.set("26", "Finished");

    for (var ctr = 26; ctr < 50; ctr++) {
      this.bolstatusMap.set(ctr + '', "Finished");
    }

    this.changeBackendPagination(this.page, this.size, false)

    $(".overlay-loading").show();
    this.service.getAssociatedTenants().subscribe(tenantResponse => {
      $(".overlay-loading").hide();
      tenantResponse.forEach(tenant => {
        if (tenant?.allowOrderFromPortal) {
          this.tenants.push(tenant);
        }
      });
    }, error => {
      $(".overlay-loading").hide();
      console.error(error);
    });

    this.service.getTblDivisions().subscribe(divisionResponse => {
      this.availableDivisions = divisionResponse;
    }, error => {
      console.error(error);
    });
    

  }

  filterCompletedBols(){
    this.changeBackendPagination(this.page, this.size, false)
  }

  changeBackendPagination(page: number, size, csvExport?: boolean) {
    if (!csvExport) {
      csvExport = false;
    }
    $(".overlay-loading").show();
    this.page = page;
    if (this.page > 0) { }
    this.size = size;
    this.clearCache = false;

    const from_date = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
    const to_date = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);

    let formatted_from_date = this.datePipe.transform(from_date, 'yyyy-MM-dd 00:00:00');
    let formatted_to_date = this.datePipe.transform(to_date, 'yyyy-MM-dd 00:00:00');

    let requestUrl = null;
    if (!this.role || this.role != "ROLE_FTP_IMPORT") {
      let url = 'get-bol-details-route-wise?size=' + this.size + '&page=' + (this.page ? (this.page - 1) : 0);
      
      this.service.hideCompletedLoads = this.hideCompletedLoads;
      this.service.filterDivision = this.filterDivision;
      this.service.shiftSorting = this.shiftSort;
      requestUrl = this.service.getBillOfladdings(
        url, formatted_from_date, formatted_to_date,
        this.filterQuery, this.orderNoFilter, this.carrierFilter,
        this.terminalFilter,
        this.supplierFilter,
        this.dealerFilter,
        this.bolStatusFilter,
        this.notesFilter,
        false,
        null,
        this.sortingModels,
        null,
        this.invoiceFilter,
        this.loadingBolFIlter,
      );
    } else {
      requestUrl = this.service.getFTPRelatedBillofladings(this.size,
        this.page - 1,
        formatted_from_date,
        formatted_to_date,
        this.carrierFilter,
        this.supplierFilter,
        this.terminalFilter,
        this.bolStatusFilter,
        this.clearCache,
        this.notesFilter,
        this.orderNoFilter,
        false,
        this.dealerFilter,
        this.filterQuery,
        this.sortingModels
      );
    }

    // $(".overlay-loading").show();
    requestUrl.subscribe(data => {
      if (csvExport) {
        var mediaType = "text/csv";
        var blob = new Blob([data], { type: mediaType });
        var filename = 'BOL-' + formatted_from_date.substr(0, 10) + '-' + formatted_to_date.substr(0, 10) + '.csv';
        importedSaveAs(blob, filename);
      } else {
        this.billOfLaddingResponse = data;
        this.allPageTotals = data.totalQuantity;
        this.totalRegQuantity = data.totalRegQuantity;
        this.totalMidQuantity = data.totalMidQuantity;
        this.totalSupQuantity = data.totalSupQuantity;
        this.totalUlsdQuantity = data.totalUlsdQuantity;
        this.totalOthQuantity = data.totalOthQuantity;

        // for(let selectedBol of this.billOfLaddingResponse.billofladings){
        //   this.calculateTimeDifferences(selectedBol);
        // }
      }
      $(".overlay-loading").hide();
    }, error => {
      console.error(error);
      $(".overlay-loading").hide();
    });

  }

  checkFilter(){
    if(this.invoiceFilter || this.loadingBolFIlter || this.orderNoFilter){
      this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 366);
      this.toDate = this.calendar.getNext(this.calendar.getToday(), 'd', 0);
    } else{
      this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 0);
      this.toDate = this.calendar.getNext(this.calendar.getToday(), 'd', 0);
    }
  }

  private calculateTimeDifferences() {
    let atRackTime, leftRackTime, atLocationTime, leftLocationTime;

    if (this.selectedItem.arrivedAtRackTime && this.selectedItem.leftRackTime) {
      atRackTime = new Date(this.selectedItem.arrivedAtRackTime);
      leftRackTime = new Date(this.selectedItem.leftRackTime);
      this.selectedItem.rackTimeDiff = (leftRackTime - atRackTime) / (1000 * 60);
    }

    if (this.selectedItem.arrivedAtCustomerTime && this.selectedItem.finalizedDeliveryTime) {
      atLocationTime = new Date(this.selectedItem.arrivedAtCustomerTime);
      leftLocationTime = new Date(this.selectedItem.finalizedDeliveryTime);
      this.selectedItem.locationTimeDiff = (leftLocationTime - atLocationTime) / (1000 * 60);
    }
  }


  /**
   * 
   * @param fileName - The name of the file
   * @param scac - Scac code of the tenant to which the user belongs
   * @param isInvoice - Is the invoice going to be generated
   */
  public downloadFile(fileName: string, scac: string, isInvoice) {
    $(".overlay-loading").show();

    this.allowedTenants.forEach(tenant => {
      if (tenant.tenantId == scac) {
        scac = tenant.scac;
      }
    });

    this.runSequentialDownload(fileName, scac, isInvoice);
  }

  // Tries pdf -> tif -> TIF. Advances to the next format on error OR on a 0-byte
  // response, and reports "No file available" when the final format is also empty.
  private runSequentialDownload(fileName: string, scac: string, isInvoice) {
    const noFileAvailable = () => {
      this.errorMsg = "No file available";
      this.error = true;
      this.errorModal.nativeElement.click();
      $(".overlay-loading").hide();
    };

    const attemptUpperTif = () => {
      const req = !isInvoice ? this.service.downloadFiles(fileName, 'TIF', scac) : this.service.downloadInvoice(fileName, 'TIF', scac);
      req.subscribe(data => {
        const blob = new Blob([data], { type: 'application/tif' });
        if (blob.size === 0) { noFileAvailable(); return; }
        importedSaveAs(blob, fileName + '.TIF');
        this.error = false;
        this.errorMsg = "[ TIF ] File downloaded successfully";
        this.errorModal.nativeElement.click();
        $(".overlay-loading").hide();
      }, error => {
        $(".overlay-loading").hide();
        if (error.status == '500' || error.status == '400') {
          this.errorMsg = "File Not Found";
          this.error = true;
          this.errorModal.nativeElement.click();
          $(".overlay-loading").hide();
        }
      });
    };

    const attemptTif = () => {
      const req = !isInvoice ? this.service.downloadFiles(fileName, 'tif', scac) : this.service.downloadInvoice(fileName, 'tif', scac);
      req.subscribe(data => {
        const blob = new Blob([data], { type: 'application/tif' });
        if (blob.size === 0) { attemptUpperTif(); return; }
        importedSaveAs(blob, fileName + '.tif');
        this.error = false;
        this.errorMsg = "[ TIF ] File downloaded successfully";
        this.errorModal.nativeElement.click();
        $(".overlay-loading").hide();
      }, error => { attemptUpperTif(); });
    };

    const req = !isInvoice ? this.service.downloadFiles(fileName, 'pdf', scac) : this.service.downloadInvoice(fileName, 'pdf', scac);
    req.subscribe(data => {
      const blob = new Blob([data], { type: 'application/pdf' });
      if (blob.size === 0) { attemptTif(); return; }
      importedSaveAs(blob, fileName + '.pdf');
      this.error = false;
      this.errorMsg = "[ PDF ] File downloaded successfully";
      this.errorModal.nativeElement.click();
      $(".overlay-loading").hide();
    }, error => {
      $(".overlay-loading").hide();
      if (error.status == '0' || error.status == '400' || error.status == '500' || error.indexOf('500 - OK {}') > -1 || error.indexOf('400 - OK {}') > -1 || error.indexOf('400') > -1 || error.indexOf('504 - OK {}') > -1) {
        attemptTif();
      }
    });
  }

  formatDateForDisplay(date){
    return this.ngbCustomDateParserService.format(date);
  }

  formatDateForDisplayHours(date){
    if(date){
      return this.datePipe.transform(date, 'HH:mm');
    } else {
      return "__:__";
    }
  }

  checkCounter(counter, value){
    if(!counter){
      return value;
    } else {
      return "";
    }
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
    this.toDate = this.fromDate;
    this.changeBackendPagination(this.page, this.size, false)
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date);
  }

  validateInput(currentValue: NgbDate, input: string): NgbDate {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  resetFilters(){
    this.selectedDealer = null;
    this.orderNoFilter = null;
    this.carrierFilter = null;
    this.terminalFilter = null;
    this.supplierFilter = null;
    this.dealerFilter = null;
    this.bolStatusFilter = null;
    this.notesFilter = null;
    this.invoiceFilter = null;
    this.loadingBolFIlter = null;
    this.filterQuery = null;
  }

  public openModalForDetails(content?: any, item?: any): void {
    this.selectedItem = item;
    this.bolImages = [];
    console.log("Selected Item", this.selectedItem);
    this.calculateTimeDifferences();

    this.selectedRouteSheet = {};
    
    this.service.getRouteForBol(this.selectedItem?.billOfLadingId, this.selectedItem?.tenant).subscribe(route => {
      console.log("Route fetched", route);
      this.selectedRouteSheet = route;
    });

    this.service.getImagesForBol("uploads/"+this.selectedItem?.billOfLadingId, this.selectedItem?.tenant).subscribe(images => {
      console.log("Images fetched", images);
      this.bolImages = images;
    });

    this.modalRef = this.ngModal.open(content, {
      size: "lg"
    });

  }

  checkTenantFiltersAvailability() {
    this.takeOrder();
  }

  displayCount() {

  }

  changeTenantFilter() {
    $(".overlay-loading").show();
    this.dealers = [];
    this.products = [];
    this.productList = [];
    this.resetOrderChanges();
    this.service.getDealersForTenant(this.userTenant).subscribe(dealers => {
      $(".overlay-loading").hide();
      this.dealers = dealers;
    }, error => {
      $(".overlay-loading").hide();
    });

    this.service.getProductsForTenant(this.userTenant).subscribe(products => {
      this.productList = products;
    })
  }

  changeDealerFilter() {

  }

  takeOrder() {
    this.products = [];
    this.service.findSelectedDealer(this.selectedDealer.locationID, this.userTenant).subscribe(dealer => {
      this.selectedDealer = dealer;
      this.service.findDealerAndStationDetails(this.selectedDealer.locationID + ':' + this.selectedDealer.tenant).subscribe(results => {
        this.availableTanks = results["tblTanks"];
        if (this.availableTanks && this.availableTanks.length > 0) {
          this.availableTanks.forEach(tank => {
            for (let productFetched of this.productList) {
              if (tank.productID == productFetched?.productId) {
                let product = this.generateProductModel(productFetched, tank);
                this.products.push(product);
              }
            }
          })
        } else {
          this.defaultProducts.forEach(defaultProduct => {
            let productCount = 0;
            for (let productFetched of this.productList) {
              if (productFetched.displayCode) {
                if (productCount == 0 && productFetched.displayCode.toLowerCase().includes(defaultProduct)) {
                  let product = this.generateProductModel(productFetched, null);
                  this.products.push(product);
                  productCount++;
                }
              }
            }
          });
        }
      });
    })

    this.service.findDeliverySlots(this.selectedDealer.tenant).subscribe(deliverySlots => {
      // this.deliverySlots = deliverySlots;
    })
  }

  private generateProductModel(productFetched: any, tank: any) {
    return {
      quantity: 0.0,
      productName: productFetched?.productName,
      class: this.utilService.selectClass(productFetched?.displayCode),
      terminalId: this.selectedDealer?.billtype?.defaultTerminal,
      supplierId: "1",
      tankName: tank?.tankName,
      productId: productFetched?.productId
    };
  }

  removeProduct(product) {
    const index: number = this.products.indexOf(product);
    if (index !== -1) {
      this.products.splice(index, 1);
    }
  }

  addProduct(product?, newProduct?) {
    if (!product) {
      product = {
        quantity: 0.0,
        productName: null,
        class: null,
        terminalId: this.selectedDealer?.billtype?.defaultTerminal,
        supplierId: "1",
        tankName: null,
        productId: null,
      };
      this.products = [product].concat(this.products);
    } else {
      product.productName = this.newProductAdded.productName;
      product.productId = this.newProductAdded.productId;
      product.class = this.utilService.selectClass(this.newProductAdded?.displayCode)
    }

  }

  captureOrder() {
    let takeOrderModels = [];
    this.products.forEach(product => {
      let copyTakeOrderModel: TakeOrderModel = JSON.parse(JSON.stringify(this.takeOrderModel));
      copyTakeOrderModel.productCode = product.productName;
      copyTakeOrderModel.productDescription = product.productName;
      copyTakeOrderModel.tankDescription = product.productName;
      copyTakeOrderModel.deliveryTimeStart = this.utilService.formatDateToSave(this.takeOrderModel.deliveryTimeStart[0]);
      copyTakeOrderModel.deliveryTimeEnd = this.utilService.formatDateToSave(this.takeOrderModel.deliveryTimeStart[1]);
      copyTakeOrderModel.productCode = product?.productId;
      copyTakeOrderModel.terminalID = product?.terminalId;
      copyTakeOrderModel.supplierID = product?.supplierId;
      copyTakeOrderModel.deliveryDate = this.utilService.formatDateToSave(this.takeOrderModel.deliveryDate);
      takeOrderModels.push(copyTakeOrderModel);
    });
    $(".overlay-loading").show();
    this.service.takeOrder(takeOrderModels, this.selectedDealer.tenant).subscribe(order => {
      $(".overlay-loading").hide();
      this.resetOrderChanges();
      this.takeOrderActive = false;
    });
  }

  resetOrderChanges() {
    this.takeOrderModel = new TakeOrderModel();
    this.products = [];
    this.takeOrderActive = false;
  }

  selectDeliveryDate() {
    this.takeOrderModel.deliveryDate =  this.utilService.formatDateOnly(this.takeOrderModel.deliveryTimeStart);
  }

  trackChanges(event) {
  }

  public openModalForTakeOrder(content?: any): void {
    // this.selectedItem = item;
    // this.bolImages = [];
    // console.log("Selected Item", this.selectedItem);
    // this.calculateTimeDifferences(this.selectedItem);

    // this.selectedRouteSheet = {};
    
    // this.service.getRouteForBol(this.selectedItem?.billOfLadingId, this.selectedItem?.tenant).subscribe(route => {
    //   console.log("Route fetched", route);
    //   this.selectedRouteSheet = route;
    // });

    // this.service.getImagesForBol("uploads/"+this.selectedItem?.billOfLadingId, this.selectedItem?.tenant).subscribe(images => {
    //   console.log("Images fetched", images);
    //   this.bolImages = images;
    // });

    this.modalRef = this.ngModal.open(content, {
      size: "lg"
    });

  }

  checkEditOption(user){
    // return user?.user?.role?.role == 'ROLE_FTP_IMPORT' || (user?.user?.role?.role == 'ROLE_DRIVER_ADMIN' && this.allowBolEditFromPortal)
    return true;
  }

  openEditModal(content, item){
    this.selectedItem = item;
    this.bolImages = [];
    console.log("Selected Item", this.selectedItem);
    this.calculateTimeDifferences();

    this.selectedRouteSheet = {};
    
    this.service.getRouteForBol(this.selectedItem?.billOfLadingId, this.selectedItem?.tenant).subscribe(route => {
      console.log("Route fetched", route);
      this.selectedRouteSheet = route;
    });

    this.service.getImagesForBol("uploads/"+this.selectedItem?.billOfLadingId, this.selectedItem?.tenant).subscribe(images => {
      console.log("Images fetched", images);
      this.bolImages = images;
    });

    this.modalRef = this.ngModal.open(content, {
      size: "lg"
    });
  }

  convertTime(time, tempTime){

    if(this.dateValidation(time) && !this.selectedItem[tempTime]){
      try{
        let convertedTime =  this.datePipe.transform(time, 'hh:mm aa')
        console.log("Converted TIme", convertedTime);
        this.selectedItem[tempTime] = convertedTime;
      } catch(e){
        
      }
    }
  }

  dateValidation(d) {
    return !!new Date(d).getTime();
  }
  
  saveLoad(){
    this.saveTDLoad();
  }

  saveTDLoad(){
    console.log("Selected Item for TD", this.selectedItem);
    $(".overlay-loading").show();
    this.selectedItem.arrivedAtRackTime = this.getDateFromTIme(this.selectedItem.arrivedAtRackTimeTemp);
    this.selectedItem.leftRackTime = this.getDateFromTIme(this.selectedItem.leftRackTimeTemp);
    this.selectedItem.arrivedAtCustomerTime = this.getDateFromTIme(this.selectedItem.arrivedAtCustomerTimeTemp);
    this.selectedItem.finalizedDeliveryTime = this.getDateFromTIme(this.selectedItem.finalizedDeliveryTimeTemp);
    if(this.billofladingNotes){
      this.selectedItem.billofladingNotes = this.selectedItem.billofladingNotes ? this.selectedItem.billofladingNotes : [];
      this.selectedItem.billofladingNotes.push(this.billofladingNotes);
    }
    this.userService.saveLoadDetailsTD(this.selectedItem).subscribe(response => {
      $(".overlay-loading").hide();
      console.log("response ", response);
      this.saveBolNote(this.selectedItem?.billOfLadingId, this.selectedItem?.tenant, this.selectedItem?.billofladingNotes);
      this.changeBackendPagination(this.page, this.size, false)
    }, error => {
      $(".overlay-loading").hide();
      console.error(error);
    })
  }

  saveBolNote(billOfLadingId, tenant, driverNotes) {
    let load={
      "billOfLadingID": billOfLadingId,
      "tenant": tenant,
      "driverNotes": driverNotes,
      "billofladingidHub": this.billofladingidHub ? this.billofladingidHub : null
    };
    $(".overlay-loading").show();
    this.userService.saveBolNote(load).subscribe(response => {
      $(".overlay-loading").hide();
      console.log("response ", response);
    }, error => {
      $(".overlay-loading").hide();
      console.error(error);
    })
  }
 

  getDateFromTIme(time){
    if(time){
    let convertedTime = this.datePipe.transform(new Date(), "yyyy-MM-dd");

    if(time?.includes('AM')){
      convertedTime += " " + time.replace(" AM", "") + ":00";
      convertedTime = this.datePipe.transform(convertedTime, 'yyyy-MM-dd HH:mm:ss');
    } else if(time?.includes('PM')){
      convertedTime += " " + time.replace(" PM", "") + ":00";
      convertedTime = this.datePipe.transform(convertedTime, 'yyyy-MM-dd HH:mm:ss');
      convertedTime = this.addHours(new Date(convertedTime), 12);
    }
    console.log("Converted TIme", convertedTime);
    return convertedTime;
  }
  }

  addHours(date, hours) {
    date.setHours(date.getHours() + hours);
    return this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss');
  }

  printDiv() {
    const css = `
    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.0/css/bootstrap.min.css"
  integrity="sha384-9gVQ4dYFwwWSjIDZnLEWnxCjeSWFphJiwGPXr1jddIhOegiu1FwO5qRGvFXOdJZ4" crossorigin="anonymous">

    <style>
    
    .time-box{
      background-color: #85ceff;
      width: 34px;
      padding: 4px;
      font-size: 10px;
      margin-left: 20%;
  }
  
  table {
      border: 1px solid #555;
      border-width: 0 0 1px 1px;
  }
  
  .table th, .table td {
      padding: 0rem;
      vertical-align: baseline;
      border-top: 1px solid #dee2e6;
      word-wrap: break-word;
      min-width: 60px;
      text-align: center;
      /* max-width: 60px; */
  }
  
  td{
    align-items: center;
    align-content: center;
    border-top: 0px solid #dee2e6;
    font-size: 10px;
    line-height: 14px;
  }
  
  table{
      font-size: 10px;
      margin-top: 0px;
      margin-left: -4px;
      padding: 0px !important;
      margin-bottom: 0px;
  }
  
  .modal-body{
      padding-top: 0px;
  }
  
  .modal-header {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      padding-left: 1rem;
      padding-right: 1rem;
      border-bottom: 1px solid #e9ecef;
      border-top-left-radius: 0.3rem;
      border-top-right-radius: 0.3rem;
  }
  
  .billofladingresponse{
      padding-top: 29px;
          font-size: 14px;
          font-weight: bold;
  }
  
  .billofladingresponsediv{
      padding: 20px; margin-top: -8px;
  }
  
  .billofladingtable{
      font-size: 12px;font-size: 12px; padding: 83px; 
                          border: 0px solid #555;
                          border-width: 0 0 0px 0px;
                          margin-top: 8px; margin-left: -4px; margin-bottom: 18px; font-weight: bold;
  }

  .shift-info{
    background-color: #ffffff;
    color: #000000; padding: 0px;
    font-weight: bold;
    border: 1px solid black;
}

    </style>`;
    var divContents = document.getElementById("billOfLaddingResponseDiv").innerHTML;
    var a = window.open('',
    '_blank',
    'width=10000,height=10000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    const pageContent = `<!DOCTYPE html><html><head>${css}</head><body onload="window.print()">${divContents}</html>`
    a.document.write(pageContent);
    a.document.close();
    // a.print();
}

findLoadColor(status){
  switch(status){
    case 10:
      return 'INT_STATUS_10';
      break;
    case 12:
      return 'INT_STATUS_12';
      break;
    case 20:
      return 'INT_STATUS_20';
      break;
    case 22:
      return 'INT_STATUS_22';
      break;
    case 24:
      return 'INT_STATUS_24';
      break;
    case 26:
      return 'INT_STATUS_26';
      break;
    case 40:
      return 'INT_STATUS_40';
      break;
    case 45:
      return 'INT_STATUS_45';
      break;
    case 50:
      return 'INT_STATUS_50';
      break;
    case 60:
      return 'INT_STATUS_60';
      break;
    case 70:
      return 'INT_STATUS_70';
      break;
  }
}


}
